export const createLinkAndDownload = (
  blobOrLink: Blob | File | string,
  filename: string
) => {
  const url =
    typeof blobOrLink === "string"
      ? blobOrLink
      : window.URL.createObjectURL(blobOrLink);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  link.remove();
};
